import { render, staticRenderFns } from "./05.mysql数据同步方案-canal高可用部署.md?vue&type=template&id=5b7b1e80"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@3.0.1_webpack@4.47.0__css-loader@2.1_bcblou4bvjpcgtlfo3nvzzlsna/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports